import { c as _c } from "react/compiler-runtime";
import { ADVISORS_VIEW_ALL_LIST_LIMIT } from '@src/components/sco/Advisors/constants';
import { filterEngagements, useAdvisorBoard } from '@src/components/sco/Advisors/hooks/useAdvisorBoard';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { AdvisorsQueryState } from '@src/components/sco/Advisors/shared/AdvisorsQueryState';
import { EngagementSearchList, EngagementSearchListItem } from '@src/components/sco/Advisors/shared/EngagementSearchList';
import { engagementCategoryBadge, engagementChatHref, engagementDisplayName } from '@src/components/sco/Advisors/utils/mapEngagements';
import { sortAdvisorBoardEngagements } from '@src/components/sco/Advisors/utils/sortEngagementsByChatActivity';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useMemo } from 'react';
export const MyAdvisorsListSection = () => {
  const $ = _c(16);
  const paths = useAdvisorsPaths();
  const {
    currentUser
  } = useCurrentUser();
  const isRegistered = !!currentUser?.isRegistered;
  let t0;
  if ($[0] !== paths.myAdvisorsAll) {
    t0 = advisorsBreadcrumbsWithTrail({
      title: "All advisors",
      href: paths.myAdvisorsAll
    });
    $[0] = paths.myAdvisorsAll;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      breadcrumbs: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useAdvisorsToolbar(t1);
  const query = useAdvisorBoard();
  query.data?.advisorBoard;
  let t2;
  if ($[4] !== isRegistered || $[5] !== paths.base || $[6] !== query.data?.advisorBoard) {
    const board = filterEngagements(query.data?.advisorBoard);
    const visible = sortAdvisorBoardEngagements(isRegistered ? board : board.filter(_temp));
    let t3;
    if ($[8] !== paths.base) {
      t3 = engagement_0 => {
        const name = engagementDisplayName(engagement_0);
        const badge = engagementCategoryBadge(engagement_0);
        const companyName = engagement_0.advisorUser?.company?.name;
        const userId = engagement_0.advisorUser?.userId;
        return {
          key: engagement_0.advisorEngagementId || engagement_0.id || name,
          name,
          href: engagementChatHref(engagement_0, paths.base),
          userId,
          subtitle: [badge.label, companyName].filter(Boolean).join(" \xB7 ") || null,
          searchText: [name, companyName, engagement_0.advisorName, badge.label].filter(Boolean).join(" ")
        };
      };
      $[8] = paths.base;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = visible.map(t3);
    $[4] = isRegistered;
    $[5] = paths.base;
    $[6] = query.data?.advisorBoard;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const items = t2;
  let t3;
  if ($[10] !== items) {
    t3 = <EngagementSearchList emptyMessage="No advisors on your board yet." items={items} maxItems={ADVISORS_VIEW_ALL_LIST_LIMIT} noMatchMessage="No advisors match your search." searchPlaceholder="Search advisors by name..." subtitle="Everyone on your board. Search by name, then open a conversation." title="All advisors" />;
    $[10] = items;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== query.error || $[13] !== query.isInitialLoading || $[14] !== t3) {
    t4 = <AdvisorsQueryState error={query.error} loading={query.isInitialLoading}>{t3}</AdvisorsQueryState>;
    $[12] = query.error;
    $[13] = query.isInitialLoading;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
function _temp(engagement) {
  return engagement.isAI;
}